<template>
    <div class="goods-order main-top-border main-bg">
        <div class="main-wrap">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="crumb">
                <el-breadcrumb-item :to="{ path: '/' }">买兰花</el-breadcrumb-item>
                <el-breadcrumb-item>选择分类</el-breadcrumb-item>
                <el-breadcrumb-item>商品详情</el-breadcrumb-item>
                <el-breadcrumb-item>确认订单</el-breadcrumb-item>
                <el-breadcrumb-item>立即支付</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="pay-box white-bg">
                <h3 class="pay-title">最后一步，请尽快付款！</h3>
                <div class="order-info">
                    <div class="money">应付金额 <span class="cell-red font-700">¥{{$common.number(payTotalMoney,2)}}</span></div>
                    <div class="info">
                        <p>商品名称：{{goodsInfo.goodsName}}</p>
                        <p>收货信息：{{addressInfo.name}}{{addressInfo.phone}}{{addressInfo.provinceName}}{{addressInfo.cityName}}{{addressInfo.areaName}}{{addressInfo.address}}</p>
                    </div>
                </div>
                <ul class="pay-type">
                    <el-radio-group v-model="payType" class="pay-group">
                        <li v-for="(item,index) in payTypeList" :key="index" @click="payType=item.id" :class="{'selected':payType==item.id}">
                            <el-radio :label="item.id" class="border-line">
                                <img class="icon" :src="item.icon" alt="">{{item.name}} <span v-show="item.id==0" v-text="$common.number(totalMoney,2)+'元'"></span>
                            </el-radio>
                        </li>
                    </el-radio-group>
                </ul>
                <el-button class="btn-big btn-main btn-small" @click="checkPayType()">确认支付</el-button>
            </div>
        </div>
        <loginDialog ref="loginDialog"></loginDialog>
        <el-dialog title="请输入支付密码" :visible.sync="dialogPayPassVisible" width="450px">
            <el-form :model="payPasswordForm" :rules="payPasswordRule"  ref="payPasswordForm">
                <el-form-item prop="payPassword">
                    <el-input v-model="payPasswordForm.payPassword" autocomplete="off" type="password" placeholder="请输入支付密码"></el-input>
                </el-form-item>
            </el-form>
            <span style="color:#F56C6C;cursor:pointer;float:right;" @click="goResetPay()">忘记密码？</span>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogPayPassVisible = false">取 消</el-button>
                <el-button type="primary" @click="checkPayPassword()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="isShowQRCode" width="300px">
            <div id="qrCode" ref="qrCode" style="width:100px;height: 100px;margin: 0 auto;"></div>
            <div style="text-align: center;padding-top: 20px;">请扫描以上二维码支付</div>
        </el-dialog>
    </div>
</template>
<script>
    import QRCode from 'qrcodejs2'
    import loginDialog from '../../../components/dialog/login'
    import {findOrderInfo,applyOnline,statusOnline} from '../../../api/order'
    import {payForAccount,payForYb,getYbUrl,getYbUrlForPc,checkPayPsd,wxPayForOrderNative,alipayForOrderQR} from '../../../api/orderPay'
    export default {
        data(){
            return {
                isShowQRCode:false,
                dialogPayPassVisible:false,
                payPasswordForm:{
                    payPassword:''
                },
                payPasswordRule:{
                    payPassword:[
                        { validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error('请输入密码'));
                            } else {
                                if(value.length!=6){
                                    callback(new Error('请输入6位支付密码'));
                                }
                                callback();
                            }
                        }, trigger: 'blur' }
                    ]
                },
                userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
                totalMoney:0,//资金余额
                orderInfo:'',
                goodsInfo:'',
                payTotalMoney:0,//应支付金额
                payType:0,//支付方式
                payTypeName:'余额支付',//支付方式
                addressInfo:'',
                payTypeList:[
                    {
                        id:0,
                        name:'账户余额',
                        icon:require('../../../assets/images/icons/icon-account.png')
                    },
//                    {
//                        id:1,
//                        name:'银行卡支付'
//                    },
                    {
                        id:2,
                        name:'微信支付',
                        icon:require('../../../assets/images/icons/icon-wechat.png')
                    },
                    {
                        id:3,
                        name:'支付宝支付',
                        icon:require('../../../assets/images/icons/icon-alipay.png')
                    },
                    /*{
                        id:4,
                        name:'线下支付'
                    },*/
                ],
                ybPayInfo:'',//易宝支付获取Token等信息
                addressIp:'',//网络IP
                qrPayImg:'',//支付二维码支付
                qrCode:''//生成二维码
            }
        },
        components:{
            loginDialog
        },
        computed:{
            orderId(){
                return this.$route.params.orderId;
            }
        },
        created () {

        },
        mounted(){
            this.getMeUserInfo();
            this.findOrderInfo();
        },
        methods:{
            goResetPay(){
                this.$store.commit('changeLoginShow',true);
                this.$refs.loginDialog.showType=5;
            },
            getMeUserInfo(){
                this.$store.dispatch('getMeInfoData',this.userInfo).then(res=>{
                    this.userInfo=res.data.user;
                    this.totalMoney=res.data.user.account;
                }).catch(err=>err)
            },
            findOrderInfo(){
                findOrderInfo({
                    userId:this.userInfo.userId,
                    orderId:this.orderId
                }).then((res)=>{
                    this.addressInfo=res.data.address;
                    this.goodsInfo=res.data.goods;
                    this.orderInfo=res.data.order;
                    this.payTotalMoney=(this.orderInfo.goodsPrice*this.orderInfo.goodsNum)+this.orderInfo.distributionFee||0.00;
                })
            },
            checkPayType(){
                let that = this;
                if(this.payType==0){
                    if(!this.$store.state.user.payPassword||this.$store.state.user.payPassword==''){
                        this.goResetPay();
                        return;
                    }else {
                        this.dialogPayPassVisible=true;
                    }
                }else if(this.payType==2){
                    this.getWeChatParams()
                }else if(this.payType==3){
                    this.getAlipaySign()
                }else if(this.payType==4){
                    this.getoutLine()
                }


            },
            getWeChatParams(){
                wxPayForOrderNative({
                    orderId:this.orderInfo.id
                }).then(res=>{
                    this.isShowQRCode=true;
                    this.$nextTick( () => {
                        document.getElementById('qrCode').innerHTML = '';
                    })
                    this.qrCode='';
                    setTimeout(function () {
                        this.qrCode = new QRCode('qrCode', {
                            width: 100,
                            height: 100, // 高度
                            text:res.data.code_url, // 二维码内容
                            render: 'canvas',   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                        });
                    },1000)
                })
            },
            getAlipaySign(){
                alipayForOrderQR({
                    orderId:this.orderInfo.id
                }).then(res=>{
                    this.isShowQRCode=true;
                    this.$nextTick( () => {
                        document.getElementById('qrCode').innerHTML = '';
                    })
                    this.qrCode='';
                    setTimeout(function () {
                        this.qrcode = new QRCode('qrCode', {
                            width: 100,
                            height: 100, // 高度
                            text:res.data.qrCode, // 二维码内容
                            render: 'canvas',   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                        });
                    },1000)
                })
            },
            getoutLine(){
                this.$confirm('申请线下支付前，请先联系商家沟通', '是否确定线下支付', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.applyOnline()
                }).catch(() => {});
            },
            applyOnline(){
                let that = this ;
                applyOnline(this.orderInfo.id).then(res=>{
                    that.$message({
                        message:res.msg,
                        type:'success'
                    });
                    setTimeout(function () {
                        that.$router.replace({path:`/myCenter/order/detail/${that.orderInfo.id}/user`})
                    },2000)

                })
            },
            checkPayPassword(){
                let that = this ;
                this.$refs['payPasswordForm'].validate((valid) => {
                    if (valid) {
                        checkPayPsd(this.payPasswordForm.payPassword).then(res=>{
                            switch (that.payType){
                                case 0:
                                    if(that.totalMoney<that.payTotalMoney){
                                        that.$message({
                                            message:'支付余额不足，请充值',
                                            type:'warning'
                                        });return false;
                                    }else {
                                        that.$confirm('是否确认支付？', '提示', {
                                            confirmButtonText: '确定',
                                            cancelButtonText: '取消',
                                            type: 'info'
                                        }).then(() => {
                                            that.payForAccount();
                                        }).catch(() => {});

                                    }
                                    break;
                                case 1:
                                    that.getPayForYbToken();
                                    break;
                                default:
                                    break;
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            getPayForYbToken(){
                payForYb({
                    userId:this.userInfo.userId,
                    orderId:this.orderInfo.id,
                    //redirectUrl:'http://192.168.110.197:3000/#/order/payOk',
                    redirectUrl:'https://www.baidu.com/'
                }).then(res=>{
                    this.ybPayInfo=res.data;
                    if(this.payType==1){
                        this.getYbUrlLink();
                    }else {
                        this.getYbUrlForPcLink();
                    }

                }).catch(err=>err)
            },
            getYbUrlLink(){
                getYbUrl({
                    token:this.ybPayInfo.token,
                    userId:this.userInfo.userId
                }).then((res)=>{
                    this.dialogPayPassVisible=false;
                    window.open(res.data);
                }).catch(err=>err)
            },
            getYbUrlForPcLink(){
                let that = this;
                let payTypeNameForPc = this.payType==2?'WECHAT':'ALIPAY';
                getYbUrlForPc({
                    token:this.ybPayInfo.token,
                    directPayType:payTypeNameForPc,
                    userId:this.userInfo.userId,
                    ip:this.addressIp
                }).then((res)=>{
                    this.dialogPayPassVisible=false;
                    this.qrPayImg=res.data;
                    this.$alert(`<img src="${that.$common.imgPath(that.qrPayImg)}" alt="${that.qrPayImg}" />`, '扫码支付', {
                        dangerouslyUseHTMLString: true
                    });

                }).catch(err=>err)
            },
            payForAccount(){
                payForAccount({
                    orderId:this.orderInfo.id,
                    userId:this.userInfo.userId
                }).then(()=>{
                    this.$message({
                        message:'支付成功',
                        type:'info'
                    });
                    this.dialogPayPassVisible=false;
                    setTimeout(()=>{
                        this.$router.push({'path':'/center/order'});
                    },2000)
                }).catch(err=>err)
            },

        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../assets/css/common";
    .crumb{
        padding:15px 0;
    }
    .pay-box{
        padding:30px 60px;
        .pay-title{
            color:#333;font-size:24px;
            font-weight:500;
            padding-bottom:30px;
        }
        .order-info{
            border:1px solid #DCDCDC;
            height:100px;
            padding:25px;
            font-size:12px;
            overflow: hidden;
            .money{
                line-height:50px;
                float: left;
                padding:0px 60px 0px 30px;

            }
            .info{
                height:100%;
                line-height:25px;
                border-left:1px solid #DCDCDC;
                float: left;
                padding-left:60px;}
        }
        .pay-type{
            width:100%;
            padding:20px 0 40px;
            color:#333;
            .pay-group{
                width:100%;
            }
            li{
                .border-line{
                    width:100%;
                    height:100%;
                    padding:18px 28px;
                    border:4px solid #fff;
                }
                &.selected{
                    .border-line{
                        box-sizing: border-box;
                        border:4px solid #96C8A6;
                    }
                }
                .icon{width:15px;height:15px;background-color:$main-color;
                    display: inline-block;
                    vertical-align: middle;margin:0px 10px 0px 20px;}

                border-bottom:1px solid #DCDCDC;
            }
        }
    }
</style>
<style lang="scss">
    @import "../../../assets/css/common";
    .el-radio__input.is-checked .el-radio__inner{background-color:$main-color;border-color:$main-color;}
    .el-radio__input.is-checked+.el-radio__label{color:#333;}
    .el-radio{color:#333;}
</style>